<template>
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="isPremium ? false : true"
        :modalBodyClass="$prefixClass.modal + '-upgrade-sucess ' + modal.type"
    >
        <img v-if="isPremium" class="m-b-24" src="@/assets/images/trial-success.svg"/>
        <template v-if="isPremium">
            <template v-if="modal.endTrial">
                <h3 :class="['primary-color m-b-12']">{{ $t('dashboard.upgrade_success.'+modal.type+'.endTrial.title') }}</h3>
                <span v-html="$t('dashboard.upgrade_success.'+modal.type+'.endTrial.description')"></span>
            </template>
            <template v-else>
                <h3 :class="['primary-color m-b-12']">{{ $t('dashboard.upgrade_success.'+modal.type+'.title') }}</h3>
                <span v-html="$t('dashboard.upgrade_success.'+modal.type+'.description')"></span>
            </template>
        </template>
        <template v-else>
            <i class="fad fa-info-circle"></i>
            <h4 :class="['m-b-12']">{{ $t('dashboard.upgrade_success.'+modal.type+'.title') }}</h4>
            <span v-html="$t('dashboard.upgrade_success.'+modal.type+'.description')"></span>
        </template>
        <div :class="[$prefixClass.modal + '-sucessfully__actions', 'm-t-24']">
            <a-button v-if="btnCancel" class="m-r-8" type="secondary" @click="onCancel">{{ btnCancel }}</a-button>
            <a-button v-if="btnOk" type="primary" @click="doAction">{{ btnOk }}</a-button>
        </div>
    </vue-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { types as typesAuth } from "@/modules/auth/constant"
import cookie from 'js-cookie'
export default {
    name: "VueModalTrialSucess",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE
        }),
        modal: {
            get: function() {
                return this.value
            },
            set: function(newValue) {
                this.$emit('input', newValue)
            }
        },
        isPremium() {
            return this.modal.type === 'premium' || this.modal.type === 'old-plan'
        },
        btnOk() {
            let btnOk = ''
            switch ( String(this.modal.type) ) {
                case 'premium':
                    if ( !this.modal.endTrial ) {
                        btnOk = this.$t('dashboard.buttons.explore_now')
                    }
                break;
                default:
                    btnOk = this.$t('dashboard.buttons.got_it')
                break;
            }
            return btnOk
        },
        btnCancel() {
            let btnCancel = ''
            switch ( String(this.modal.type) ) {
                case 'premium':
                    if ( this.modal.endTrial ) {
                        btnCancel = this.$t('dashboard.buttons.done')
                    } else {
                        btnCancel = this.$t('dashboard.buttons.later')
                    }
                break;
                default:
                break;
            }
            return btnCancel
        }
    },
    methods: {
        onCancel() {
            this.modal.isVisible = false
        },
        doAction() {
            this.onCancel()
            switch ( String(this.modal.type) ) {
                case 'premium':
                    this.$router.push({
                        name: this.$routerName.OPTIMIZE_IMAGE
                    })
                break;
                case 'free':
                break;
                case 'old-plan':
                    cookie.set( 'hide-modal-plan-notification' , true , { expires: 30 })
                break;
            }
        }
    }
}
</script>
<style lang="scss">
    .m-modal-upgrade-sucess {
        text-align: center;
        &.premium, &.old-plan {
            width: 540px !important;
            .m-modal {
                &-body {
                    padding: 32px 74px;
                }
            }
        }
        &.old-plan {
            .m-modal {
                &-body {
                    padding: 32px 44px;
                }
            }
        }
        &.free {
            width: 480px !important;
            .m-modal {
                &-body {
                    padding: 32px;
                    .fa-info-circle {
                        font-size: 48px;
                        color: $primary-color;
                        opacity: 0.5;
                        margin-bottom: 14px;
                    }
                }
            }
        }
        
        .m-modal {
            &-content {
                border-radius: 8px;
            }
        }
    }
    
</style>
